var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tooltip',{attrs:{"label":"Supprimer"}},[_c('b-button',{staticClass:"rounded button is-danger is-light rounded-lg text-decoration-none mr-1",attrs:{"loading":_vm.isLoading},on:{"click":function($event){$event.preventDefault();return _vm.confirm.apply(null, arguments)}}},[_c('b-icon',{attrs:{"icon":"times"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }